<template>
  <div id="locations-content">
      
    <div id="saved-view" :class="{ indicators: $route.name === 'indicators', hidden: !visible, expanded: selectedEngagement }">
      <label id="toggle-hidden"><input type="checkbox" v-model="visible" /></label>

      <div class="location-section">
        <img src="../assets/logo-small.png" alt="Forests in Focus" />
        <img class="float-right" src="../assets/logos-conjunction.png" alt="Forests in Focus" />
      </div>

      <div v-if="$route.name === 'locations' && !saveForm">

        <div class="location-section">
          <h4><i class="fa fa-map-marker"></i> Mill Locator</h4>
          <div>Select Pins Below</div>
        </div>

        <mill-list @millClick="toggleSelectedMill" :mills="mills"></mill-list>

        <div class="text-center">
          <button class="button hollow save-view-btn" :disabled="selectedMills.length === 0" @click="saved = true; saveForm = true; setMapImage('static-zoom-in2.png')">
            <i class="fa fa-map-marker"></i> Save As View
          </button>
        </div>
      </div>
      <div v-else>

        <div v-if="$route.name !== 'indicators' && $route.name !== 'savedViews'">

          <div class="location-section">
            <h4><i class="fa fa-map-marker"></i> Mill Locator</h4>
            <div>Please provide a name to save this view.</div>
          </div>


          <div class="location-section white">
            <div class="input-group">
              <input class="input-group-field" type="text" v-model="savedViewName" placeholder="Name this view" />
              <div class="input-group-button" @click="visible = false">
                <router-link class="button" :to="{ name: 'indicators' }">
                  Save
                </router-link>
              </div>
            </div>
            <div class="composite-score">
              This view's composite score: {{compositeScore}}%
              <i class="fa fa-check"></i>
            </div>
          </div>

        </div>
        <div v-else-if="$route.name === 'savedViews'">

          <div class="location-section saved-view-header">
            <h4><i class="fa fa-bookmark"></i> My Saved Views</h4>
            <div>You have 1 saved landscape</div>
          </div>
          <div class="location-section white">
            <h6><i class="fa fa-bookmark"></i> {{savedViewName}}</h6>
            <div class="composite-score">
              This view's composite score: {{compositeScore}}%
              <i class="fa fa-check"></i>
            </div>
          </div>

        </div>
        <div class="engagements" v-else-if="!selectedEngagement">
          <h4>Engagement Opportunities</h4>

          <div class="engagement" v-for="engagement in $store.state.engagements" v-if="engagementActive(engagement.indicators)">
            <img v-if="engagement.image" :src="loadImg(engagement.image)" />
            <div class="engagement-content">
              <h5 @click="engagement.active = !engagement.active">
                {{ engagement.title }}
              </h5>
              <div class="selected-indicators">
                <div v-for="oi in engagement.indicators">
                  {{ oi }}
                  <div class="stars">
                    <i v-for="i in 4" :class="{ active: i <= getIndicator(oi).oppLevel }" class="fa fa-circle-o"></i>
                  </div>
                </div>
              </div>
              <i class="fa fa-heart" :class="{ active: engagement.heart }" @click="engagement.heart = !engagement.heart"></i>
              <i class="fa" @click="engagement.active = !engagement.active" :class="{ 'fa-chevron-up': engagement.active, 'fa-chevron-down': !engagement.active }"></i>
              <div class="engagement-description" v-if="engagement.active">
                {{ engagement.excerpt }}
                <div class="engagement-details">
                  <a :href="engagement.link">Link</a>
                  <button class="button tiny" @click="selectedEngagement=engagement">
                    Read More
                  </button>
                  <button class="button tiny" v-if="engagement.donations">Donate</button>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="engagements selected-engagement" v-else-if="selectedEngagement">
          <div class="engagement-content">
            <h4>{{ selectedEngagement.title }}</h4>
            <div class="engagement-description" v-html="selectedEngagement.description"></div>
          </div>
          <div class="engagement-sidebar">
            <button class="back button" @click="selectedEngagement=null">Back to Engagement Opportunities</button>

            <h5>Engagement Indicators</h5>
            <div class="selected-indicators">
              <div v-for="oi in selectedEngagement.indicators">
                <span>{{ oi }}</span>
                <div class="stars">
                  <i v-for="i in 4" :class="{ active: i <= getIndicator(oi).oppLevel }" class="fa fa-circle-o"></i>
                </div>
              </div>
            </div>

            <h5>Partner Logos</h5>
            <div class="engagement-logos">
              <img v-for="logo in selectedEngagement.logos" :src="logo" />
            </div>

            <h5>Additional Resources</h5>
            <div class="engagement-details">
              <a :href="selectedEngagement.link" target="_blank">
                <i class="fa fa-external-link"></i> External Link
              </a>

              <a v-if="selectedEngagement.download" :href="selectedEngagement.download">
                <i class="fa fa-download"></i> Download
              </a>
            </div>
          </div>
        </div>

        <mill-list :mills="selectedMills" v-if="$route.name !== 'indicators'"></mill-list>

        <div class="view-indicators" v-if="$route.name === 'savedViews'">
          <router-link class="button" :to="{ name: 'indicators' }">
            View Indicators
          </router-link>
        </div>

      </div>

    </div>

    <div id="map-content" :class="[{indicators: $route.name === 'indicators'}, 'no-stretch']">
      <div id="map-wrap">
        <div class="map-markers" v-if="!saveForm && $route.name === 'locations'">
          <img class="toggle-map-marker" 
            :style="{top: mill.top, left: mill.left}" 
            :src="imageMillSelected(mill)" 
            @click="toggleSelectedMill(mill)" 
            v-for="mill, index in mills" 
            :key="index">
        </div>

        <div id="county-trigger-0" class="county-trigger" @click="showCountyCards(0)" v-if="$route.name === 'indicators'"></div>
        <div id="county-trigger-1" class="county-trigger" @click="showCountyCards(1)" v-if="$route.name === 'indicators'"></div>

        <img @click="hideCountyCards" id="zoom-map-static" :src="mapImage" />
      </div>
    </div>

      <transition name="fade">
        <county-cards 
          v-if="countyCardsActive !== false"
          :id="'county-cards-container-' + countyCardsActive" 
          :county="countyCardsActive"></county-cards>
      </transition>

    <transition name="indicators-in-out" v-if="$route.name !== 'savedViews'">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import L from 'leaflet'
import MillList from './MillList';
import CountyCards from './CountyCards';

export default {
  components: {
    'mill-list': MillList,
    'county-cards': CountyCards
  },
  name: 'locations',
  watch: {
    '$route': function () {
      if(this.$route.name !== 'indicators') {
        this.countyCardsActive = false
      }
    }
  },
  methods: {
    loadImg: function (path) {
      return require('../assets/' + path)
    },
    toggleSelectedMill(mill) {
      if(this.selectedMills.indexOf(mill) === -1) {
        this.selectedMills.push(mill);
      } else {
        this.$store.commit('setSelectedMills', _.without( this.selectedMills, mill ));
        console.log(this.selectedMills);
      }
    },
    setMapImage(img) {
      this.mapImage = require('../assets/' + img)
    },
    hideCountyCards() {
      if(this.$route.name === 'indicators') {
        this.countyCardsActive = false
        this.resetMapImage()
      }
    },
    showCountyCards(county) {
      if(this.countyCardsActive !== county) {
        this.countyCardsActive = false
        this.$nextTick(function(){
          this.countyCardsActive = county
          this.resetMapImage()
        })
      } else {
        this.countyCardsActive = false
        this.resetMapImage()
      }
    },
    resetMapImage() {
      var coreIndicators = _.countBy(this.indicators[1].indicators, function(i) { return i.active ? 'active' : 'inactive'; })

      if(this.indicators[1].indicators[0].active && coreIndicators.active === 1) {
        this.setMapImage(this.countyCardsActive !== false  ? 'static-zoom-county-'+this.countyCardsActive+'-core.png' : 'static-zoom-in4.png')
      } else if( this.countyCardsActive !== false ) {
        this.setMapImage(!coreIndicators.active ? 'static-zoom-county-'+this.countyCardsActive+'-inactive.png' : 'static-zoom-county-'+this.countyCardsActive+'.png')
      } else {
        this.setMapImage('static-zoom-in3.png')
      }

    },
    imageMillSelected(mill) {
      return this.selectedMills.indexOf(mill) !== -1 ? require('../assets/pin-blue.png') : require('../assets/pin-grey.png')
    },
    engagementActive(indicators) {
      var activeIndicators = [];

      this.indicators.forEach(function (group) {
        group.indicators.forEach(function (indicator) {
          if (!indicator.active) {
            return;
          }

          activeIndicators.push(indicator.name);
        });
      });

      return indicators.some(function (name) {
        return activeIndicators.indexOf(name) !== -1;
      });
    },
    getIndicator(name) {
      return this.selectedCounty.indicators[2].find(function (i) {
        return i.name === name;
      }) || {};
    }
  },
  computed: {
    mills () {
      return this.$store.getters.getMills
    },
    selectedMills() {
      return this.$store.getters.getSelectedMills
    },
    compositeScore() {
      return (_.reduce(this.selectedMills, function(sum, mill){ return sum + mill.percentage; }, 0) / this.selectedMills.length).toFixed(1);
    },
    indicators () {
      return this.$store.getters.getIndicators
    },
    selectedCounty() {
      var selected = this.$store.state.selectedCounty;

      return this.$store.state.counties.find(function (c) {
        return selected === c.county;
      });
    }
  },
  created (){

  },
  updated () {
    var self = this;

    _.debounce(function () {
      if (self.$route.name === 'savedViews') {
        self.savedViewName = 'Default View';
        self.setMapImage('static-zoom-in2.png');

        if (!self.saved || self.$store.getters.getSelectedMills.length < 1) {
          self.$store.commit('setSelectedMills', self.$store.getters.getDefaultMills);
        }
      } else {
        self.saved = false;
      }
    }, 50)();
  },
  mounted (){
    if (this.$route.name === 'locations') {
      this.$store.commit('setSelectedMills', []);
    } else if (this.$route.name === 'savedViews') {
      this.savedViewName = 'Default View';
      // this.saveForm = true;
    }

    // this.map = L.map('leaflet-map').setView([39.8282, -98.5795], 4);
    // L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png').addTo(this.map);
  },
  data () {
    return {
      msg: 'Locations',
      map: null,
      saved: false,
      saveForm: this.$store.state.saveForm,
      savedViewName: '',
      mapImage: require('../assets/static-zoom-in.png'),
      countyCardsActive: false,
      visible: true,
      selectedEngagement: null
    }
  }
}
</script>

<style lang="scss">
@import "~leaflet/dist/leaflet.css";
@import '../scss/global';

#locations-content {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  background: #F9F8F7;

  .selected-indicators {
    min-width: 225px;
    float: right;
    margin-left: 1rem;
    margin-bottom: 1rem;
  }

  .engagement-details {
    margin-top: 1em;

    a {
      display: block;
    }
  }

  .engagement-sidebar {
    width: 250px;
    position: absolute;
    right: 0;
    top: 0;
    padding: 1rem;
    padding-left: 0px;

    .selected-indicators {
      float: none;
      padding-right: 1em;
    }

    h5 {
      color: white;
      background-color: $primary-color;
      padding: 0.25rem 0.5rem;
      text-transform: uppercase;
      font-size: 0.85em;
      margin-top: 4rem;
    }
  }

  .engagement-logos {
    img {
      margin-top: 1em;
      margin-bottom: 1em;
      max-height: 50px;
    }
  }

  .selected-engagement {
    .button.download {
      display: block;
      margin-top: 1em;
    }

    .engagement-content {
      margin-right: 275px;
    }
  }

  .engagement-description {
    h3, h4, h5 {
      margin-top: 1em;
    }
  }

  .stars {
    float: right;
  }

  .fa-circle-o {
    color: #43392d;
    opacity: 0.20;
    letter-spacing: 2px;
    font-size: 1.25em;

    &.active {
      opacity: 0.75;
      color: #43392d;

      &:before {
        content: '\f111' !important;
      }
    }
  }

  .location-section {
    padding: 15px;
    border-bottom: 1px solid #E4E3DF;
    &.white {
      background: $white;
      border-bottom: none;
    }
  }

  .view-indicators {
    margin: 0 1em;
    text-align: right;
  }

  .engagements {
    padding: 1em;
    background-color: #FFF;
    padding-top: 2em;
    position: relative;

    h4 {
      margin-bottom: 1.25em;
    }

    .engagement {
      position: relative;
      border-bottom: 1px solid #CCC;
      padding-bottom: 0.5em;
      margin-bottom: 1em;
      overflow: auto;

      .fa, h5 {
        cursor: pointer;
      }

      h5 {
        font-size: .9em;
        margin-right: 3rem;
        line-height: 1.15;
        margin-bottom: 1.5em;
      }

      .engagement-content {
        margin-left: 4em;

        .button {
          float: right;
          margin-left: 1em;
        }
      }

      .engagement-description {
        margin-bottom: 1em;
        font-size: 0.8em;
      }

      img {
        max-width: 50px;
        margin-right: 0.5em;
        float: left;
      }

      .fa-heart {
        position: absolute;
        top: 0.5em;
        right: 2em;
        font-size: .9rem;
        color: #DADADA;
        opacity: 0.5;

        &.active {
          color: #B00;
        }

        &:not(.active):hover {
          color: #B00;
          opacity: 0.15;
        }
      }

      .fa-chevron-down, .fa-chevron-up {
        opacity: 0.75;
        position: absolute;
        top: 0.5em;
        right: 0em;
        font-size: 0.9rem;
      }

      .fa-chevron-down {
        opacity: 0.35;
      }
    }
  }
}

.button.hollow.save-view-btn {
  border-radius: 30px;
  padding-left: 30px;
  padding-right: 30px;
  text-transform: uppercase;
  font-size: 16px;
  &:hover {
    background: $primary-color;
    color: $white;
  }
  &:disabled {
    background: transparent;
    color: $primary-color;
    opacity: 0.3;
  }
}

#saved-view {
  width: $sidebar-width;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  box-shadow: 0 0 15px transparentize(#000, 0.5);
  z-index: 5;
  overflow: auto;
  color: #505050;
  background-color: #f5f5f2;

  @include breakpoint (small only) {
    &.hidden {
      left: ($sidebar-width - 50) * -1;

      + #map-content {
        width: 100%;
      }
    }
  }

  .composite-score {
    color: $primary-color;
    margin-left: 1.5rem;
    text-transform: uppercase;
    font-size: 0.9em;
  }

  #toggle-hidden {
    position: absolute;
    right: 0;
    top: 0;

    @include breakpoint (medium up) {
      display: none;
    }
  }
}

.saved-view-header {
  h4 {
    text-transform: uppercase;
  }
  div {
    font-size: 0.95em;
  }
}

.fa-bookmark {
  margin-right: 0.5rem;
}

.mill-selected {
  color: #999;
  &.selected {
    color: #4B91E2;
  }
}

#map-content {
  width: calc(100% - #{$sidebar-width});
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  background: #f5f5f2;
  z-index: 1;
  overflow: hidden;

  #map-wrap {
    position: absolute;
    width: 100%;
    height: 0;
    padding-bottom: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }

  span {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    font-size: 72px;
    color: darken(#f5f5f2, 25%);
  }

  #leaflet-map {
    width: 100%;
    height: 100%;
  }

  #country-map-static {
    max-width: 90%;
    max-height: 90%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }

  #zoom-map-static {
    min-width: 100%;
    min-height: 100%;
    max-width: none;
    max-height: none;
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translate(-50%,-50%);
  }

  .map-markers {
    height: 900px;
    width: 1000px;
    max-width: 70%;
    max-height: 70%;
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translate(-50%,-50%);
    z-index: 10;
  }

  &.no-stretch #zoom-map-static {
    min-height: 0;
    min-width: 0;
    height: 100%;
    width: 100%;
  }

}

#saved-view, #map-content {
  position: absolute;
  transition: all $animation-speed;
  &.indicators {
    height: 535px;
    @include breakpoint(1440px up) {
      height: 650px;
    }
  }
}

#saved-view.expanded {
  width: 75%;
}

@keyframes indicators-in {
  from { bottom: -1 * $indicator-height; }
  to { bottom: 0; }
}
@keyframes indicators-out {
  from { bottom: 0; }
  to { bottom: -1 * $indicator-height; }
}

.indicators-in-out-enter-active {
  position: absolute;
  animation: indicators-in $animation-speed;
}
.indicators-in-out-leave-active {
  position: absolute;
  animation: indicators-out $animation-speed;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}

.toggle-map-marker {
  position: absolute;
  z-index: 9;
}

.county-trigger {
  position: absolute;
  left: 50%;
  top: 50%;
  cursor: pointer;  
  z-index: 9;
}
#county-trigger-0 {
  width: 7.5%;
  height: 9.5%;
  // background: rgba(0,0,0,0.5);
  top: 48%;
  left: 41%;
}
#county-trigger-1 {
  // background: rgba(255,0,0,0.5);
  top: 53.5%;
  left: 49%;
  height: 18%;
  width: 9%;
}

// #county-cards-container-0, #county-cards-container-1 {
//   &:after {
//     content: '';
//     display: block;
//     width: 0;
//     height: 0;
//     border-style: solid;
//     border-width: 200px 5px 0 5px;
//     border-color: #6d9e35 transparent transparent transparent;
//     position: absolute;
//     opacity: 0.5;
//   }
// }

#county-cards-container-0 {
  position: absolute;
  top: 0;
  z-index: 9;
  left: 690px;
  &:after {
    top: 90px;
    right: 10px;
    transform: rotate(-45deg);
  }
}

#county-cards-container-1 {
  position: absolute;
  top: 0px;
  z-index: 9;
  right: 10px;
  &:after {
    top: 150px;
    left: -340px;
    transform: rotate(45deg);
  }
}

</style>



// WEBPACK FOOTER //
// Locations.vue?48c721d7